// LuxPlus Experience Discount Takeover Constants
// This takeover is triggered via CX API

export const LUX_PLUS_EXPERIENCE_DISCOUNT_TAKEOVER_ID = 'luxplus-10off-experience'
export const LUX_PLUS_EXPERIENCE_DISCOUNT_CAMPAIGN_ID = 'LuxPlus+ Experience Discount'
export const LUX_PLUS_EXPERIENCE_DISCOUNT_ALL_OFFERS_URL = '/search/experiences?destinationId=le_d41d8cd98f00b204e9800998ecf8427e&destinationName=Anywhere'
export const LUX_PLUS_EXPERIENCE_DISCOUNT_BECOME_MEMBER_URL = '/lux-plus?luxplusExclusiveOffer=true'
